import { AuthService } from 'src/app/core/auth/auth.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  constructor(private auth: AuthService, private router: Router) {}

  ngOnInit(): void {
    this.auth.estaAutenticado('/home');
  }

  onLogin(respuesta): void {
    if (respuesta) this.router.navigateByUrl('/home');
  }
}
